module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-600italic.f67c3e9.woff2";